import CancelledReason from '@/models/Shared/CancelledReason';
import BaseUpdateRequest from '@/models/Shared/BaseUpdateRequest';

export default class CancelShiftViewModel extends BaseUpdateRequest {
    shiftId: string;
    bookingRoleId: string;
    cancelledReason: CancelledReason;
}